import React from 'react';
import styles from './card.module.css';

export const Card = React.forwardRef(({children, className = '', columns = 1, style = {}, ...props}, ref) => {
    return <div
        className={styles.Card + ' ' + className}
        style={{
            gridColumn: `span min(var(--columns-count), ${columns})`,
            ...style
        }}
        {...props}
        ref={ref}
    >{children}</div>;
});